import { useEffect, useState } from 'react';
import { Header } from '../../components/Header/Header';
import './Room.css';
import { FloatButton } from '../../components/FloatButton/FloatButton';
import { useNavigate } from 'react-router-dom';

export const Room = (props) => {
  const { cdn, room } = props;
  const navigate = useNavigate();

  const [building, setBuilding] = useState('');
  const [level, setLevel] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const initialZoom = room.scale.preview;
  const initialPan = room.coords.preview;

  const navTo = () => {
    navigate(`/fullscreen/${room.label.toLowerCase().replace(/\s/g, '_')}`);
  };

  useEffect(() => {
    const levelCode = room.level.split('');

    if (levelCode.length === 3) {
      setBuilding(levelCode[1] + levelCode[2]);
    } else {
      setBuilding(levelCode[1]);
    }

    setLevel(levelCode[0]);
  }, [room]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="page room-page">
      <Header cdn={cdn} btn="back" />
      <div className="room-page__content">
        <div className="room-page__content__head">
          <div className="room-page__content__head__title">Salle de réunion</div>
          <div className="room-page__content__head__room">{room.label}</div>
        </div>
        <div className="room-page__content__preview">
          <div className="room-page__content__preview__head">
            <div className="room-page__content__preview__head__building">Bâtiment {building}</div>
            <div className="room-page__content__preview__head__level">- Niveau {level}</div>
          </div>

          <div className="room-page__content__preview__container__plan" onClick={navTo}>
            {isLoading ? (
              <div className="room-page__content__preview__container__loader">
                <img
                  className="room-page__content__preview__container__loader__img"
                  alt="Chargement"
                  src={`${cdn}pictos/load.svg`}
                />
              </div>
            ) : null}
            <object
              className="room-page__content__preview__container__plan__img"
              type="image/svg+xml"
              data={`${cdn}plans/plan_${room.level}.svg`}
              style={{
                transform: `scale(${initialZoom}) translate(${initialPan.x}%, ${initialPan.y}%)`,
                transformOrigin: 'top left',
              }}
            >
              Plan
            </object>
            <FloatButton cdn={cdn} type={'expand'} />
          </div>
        </div>
      </div>
    </div>
  );
};
